import { createFileRoute } from '@tanstack/react-router';

import { BaselinesPage } from '@/features/siteplan/baselines-page';

export const Route = createFileRoute('/_app/projects/$projectId/plan/baselines')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <BaselinesPage projectId={projectId} />;
}
